<div
  class="modal-body">
  <render-product-purchase-options
    class="product-sizes"
    [product]="props.data.product"
    [imageDetails]="props.data.imageDetails"
    [country]="props.data.country"
    [lang]="props.data.lang"
    [piece]="props.data.piece"
    [isModal]="true">
  </render-product-purchase-options>
</div>
